import { render } from "./SubscriptionsCreateView.vue?vue&type=template&id=4b176326"
import script from "./SubscriptionsCreateView.vue?vue&type=script&lang=js"
export * from "./SubscriptionsCreateView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__